<template>
    <div class="rn-service-area rn-section-gapTop">
        <div class="container">
            <div class="row">
                <div class="col-12 mb--50">
                    <h3 class="title" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">Services</h3>
                </div>
            </div>
            <div class="row g-5">
                <template v-for="(service, index) in serviceList"
                          :key="`service-${index}`">
                    <div v-if="index < serviceLimit" :class="serviceColumn">
                        <service-card :service-data="service"/>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import ServiceCard from '@/components/service/ServiceCard'

    export default {
        name: 'ServiceStyleOne',
        components: {ServiceCard},
        props: {
            serviceLimit: {
                type: Number,
                default: 4
            },
            serviceColumn: {
                type: String,
                default: 'col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12'
            }
        },
        data() {
            return {
                serviceList: [
                    {
                        image: require(`@/assets/images/icons/home/icon_basket.png`),
                        subtitle: 'E-Commerce',
                        title: 'Web Development & E-Commerce',
                        description: `We create fast, responsive, and scalable websites that engage users and drive sales. From simple company pages to fully functional e-commerce stores, our solutions are tailored to your business.`,
                        link: '/connect'
                    },
                    {
                        image: require(`@/assets/images/icons/home/icon_design.png`),
                        subtitle: 'Design',
                        title: 'Graphic Design',
                        description: `Visual identity matters. We craft modern, creative designs – from brand logos to full website visuals – that communicate your values and connect with your audience.`,
                        link: '/collection'
                    },
                    {
                        image: require(`@/assets/images/icons/home/icon_seo.png`),
                        subtitle: 'Marketing',
                        title: `SEO & Digital Marketing`,
                        description: `Through SEO, social media campaigns, and targeted marketing, we ensure your brand reaches the right people at the right time. We turn clicks into loyal customers.`,
                        link: '/connect'
                    },
                    {
                        image: require(`@/assets/images/icons/home/icon_ecommerce.png`),
                        subtitle: 'Development',
                        title: `Custom Software Development`,
                        description: `From automation tools to fully custom apps, we build software that solves your unique challenges. Scalable, secure, and built for growth.`,
                        link: '/creator'
                    }
                ],
            }
        }
    }
</script>